import React, { useEffect } from "react";
import { trackEvent } from "./analytics";

export const App = ({ children }) => {
  useEffect(() => {
    window.vonxaiTrack = trackEvent;
  }, []);

  return <>{children}</>;
};

export const wrapPageElement = ({ element }) => <App>{element}</App>;
